export const genBoxWearables = [
  { templateId: 252, contract: 'Wearable', probability: null },
  { templateId: 282, contract: 'Wearable', probability: null },
  { templateId: 309, contract: 'Wearable', probability: null },
  { templateId: 321, contract: 'Wearable', probability: null },
  { templateId: 329, contract: 'Wearable', probability: null },
  { templateId: 367, contract: 'Wearable', probability: null },
  { templateId: 380, contract: 'Wearable', probability: null },
  { templateId: 381, contract: 'Wearable', probability: null },
  { templateId: 390, contract: 'Wearable', probability: null },
  { templateId: 421, contract: 'Wearable', probability: null },
  { templateId: 439, contract: 'Wearable', probability: null },
  { templateId: 446, contract: 'Wearable', probability: null },
  { templateId: 246, contract: 'Wearable', probability: null },
  { templateId: 249, contract: 'Wearable', probability: null },
  { templateId: 250, contract: 'Wearable', probability: null },
  { templateId: 260, contract: 'Wearable', probability: null },
  { templateId: 261, contract: 'Wearable', probability: null },
  { templateId: 267, contract: 'Wearable', probability: null },
  { templateId: 269, contract: 'Wearable', probability: null },
  { templateId: 275, contract: 'Wearable', probability: null },
  { templateId: 279, contract: 'Wearable', probability: null },
  { templateId: 281, contract: 'Wearable', probability: null },
  { templateId: 283, contract: 'Wearable', probability: null },
  { templateId: 285, contract: 'Wearable', probability: null },
  { templateId: 288, contract: 'Wearable', probability: null },
  { templateId: 293, contract: 'Wearable', probability: null },
  { templateId: 298, contract: 'Wearable', probability: null },
  { templateId: 302, contract: 'Wearable', probability: null },
  { templateId: 305, contract: 'Wearable', probability: null },
  { templateId: 307, contract: 'Wearable', probability: null },
  { templateId: 312, contract: 'Wearable', probability: null },
  { templateId: 313, contract: 'Wearable', probability: null },
  { templateId: 318, contract: 'Wearable', probability: null },
  { templateId: 320, contract: 'Wearable', probability: null },
  { templateId: 322, contract: 'Wearable', probability: null },
  { templateId: 323, contract: 'Wearable', probability: null },
  { templateId: 327, contract: 'Wearable', probability: null },
  { templateId: 328, contract: 'Wearable', probability: null },
  { templateId: 330, contract: 'Wearable', probability: null },
  { templateId: 333, contract: 'Wearable', probability: null },
  { templateId: 334, contract: 'Wearable', probability: null },
  { templateId: 345, contract: 'Wearable', probability: null },
  { templateId: 353, contract: 'Wearable', probability: null },
  { templateId: 356, contract: 'Wearable', probability: null },
  { templateId: 357, contract: 'Wearable', probability: null },
  { templateId: 358, contract: 'Wearable', probability: null },
  { templateId: 359, contract: 'Wearable', probability: null },
  { templateId: 360, contract: 'Wearable', probability: null },
  { templateId: 361, contract: 'Wearable', probability: null },
  { templateId: 366, contract: 'Wearable', probability: null },
  { templateId: 379, contract: 'Wearable', probability: null },
  { templateId: 388, contract: 'Wearable', probability: null },
  { templateId: 391, contract: 'Wearable', probability: null },
  { templateId: 392, contract: 'Wearable', probability: null },
  { templateId: 393, contract: 'Wearable', probability: null },
  { templateId: 394, contract: 'Wearable', probability: null },
  { templateId: 398, contract: 'Wearable', probability: null },
  { templateId: 401, contract: 'Wearable', probability: null },
  { templateId: 402, contract: 'Wearable', probability: null },
  { templateId: 405, contract: 'Wearable', probability: null },
  { templateId: 414, contract: 'Wearable', probability: null },
  { templateId: 416, contract: 'Wearable', probability: null },
  { templateId: 417, contract: 'Wearable', probability: null },
  { templateId: 418, contract: 'Wearable', probability: null },
  { templateId: 419, contract: 'Wearable', probability: null },
  { templateId: 427, contract: 'Wearable', probability: null },
  { templateId: 430, contract: 'Wearable', probability: null },
  { templateId: 438, contract: 'Wearable', probability: null },
  { templateId: 440, contract: 'Wearable', probability: null },
  { templateId: 441, contract: 'Wearable', probability: null },
  { templateId: 247, contract: 'Wearable', probability: null },
  { templateId: 248, contract: 'Wearable', probability: null },
  { templateId: 251, contract: 'Wearable', probability: null },
  { templateId: 253, contract: 'Wearable', probability: null },
  { templateId: 254, contract: 'Wearable', probability: null },
  { templateId: 255, contract: 'Wearable', probability: null },
  { templateId: 256, contract: 'Wearable', probability: null },
  { templateId: 257, contract: 'Wearable', probability: null },
  { templateId: 258, contract: 'Wearable', probability: null },
  { templateId: 259, contract: 'Wearable', probability: null },
  { templateId: 262, contract: 'Wearable', probability: null },
  { templateId: 263, contract: 'Wearable', probability: null },
  { templateId: 264, contract: 'Wearable', probability: null },
  { templateId: 265, contract: 'Wearable', probability: null },
  { templateId: 266, contract: 'Wearable', probability: null },
  { templateId: 268, contract: 'Wearable', probability: null },
  { templateId: 270, contract: 'Wearable', probability: null },
  { templateId: 271, contract: 'Wearable', probability: null },
  { templateId: 272, contract: 'Wearable', probability: null },
  { templateId: 273, contract: 'Wearable', probability: null },
  { templateId: 274, contract: 'Wearable', probability: null },
  { templateId: 276, contract: 'Wearable', probability: null },
  { templateId: 277, contract: 'Wearable', probability: null },
  { templateId: 278, contract: 'Wearable', probability: null },
  { templateId: 284, contract: 'Wearable', probability: null },
  { templateId: 286, contract: 'Wearable', probability: null },
  { templateId: 287, contract: 'Wearable', probability: null },
  { templateId: 289, contract: 'Wearable', probability: null },
  { templateId: 290, contract: 'Wearable', probability: null },
  { templateId: 291, contract: 'Wearable', probability: null },
  { templateId: 292, contract: 'Wearable', probability: null },
  { templateId: 294, contract: 'Wearable', probability: null },
  { templateId: 295, contract: 'Wearable', probability: null },
  { templateId: 296, contract: 'Wearable', probability: null },
  { templateId: 297, contract: 'Wearable', probability: null },
  { templateId: 299, contract: 'Wearable', probability: null },
  { templateId: 300, contract: 'Wearable', probability: null },
  { templateId: 301, contract: 'Wearable', probability: null },
  { templateId: 303, contract: 'Wearable', probability: null },
  { templateId: 304, contract: 'Wearable', probability: null },
  { templateId: 306, contract: 'Wearable', probability: null },
  { templateId: 308, contract: 'Wearable', probability: null },
  { templateId: 310, contract: 'Wearable', probability: null },
  { templateId: 311, contract: 'Wearable', probability: null },
  { templateId: 314, contract: 'Wearable', probability: null },
  { templateId: 315, contract: 'Wearable', probability: null },
  { templateId: 316, contract: 'Wearable', probability: null },
  { templateId: 317, contract: 'Wearable', probability: null },
  { templateId: 319, contract: 'Wearable', probability: null },
  { templateId: 324, contract: 'Wearable', probability: null },
  { templateId: 325, contract: 'Wearable', probability: null },
  { templateId: 326, contract: 'Wearable', probability: null },
  { templateId: 331, contract: 'Wearable', probability: null },
  { templateId: 332, contract: 'Wearable', probability: null },
  { templateId: 335, contract: 'Wearable', probability: null },
  { templateId: 336, contract: 'Wearable', probability: null },
  { templateId: 337, contract: 'Wearable', probability: null },
  { templateId: 338, contract: 'Wearable', probability: null },
  { templateId: 339, contract: 'Wearable', probability: null },
  { templateId: 340, contract: 'Wearable', probability: null },
  { templateId: 341, contract: 'Wearable', probability: null },
  { templateId: 342, contract: 'Wearable', probability: null },
  { templateId: 343, contract: 'Wearable', probability: null },
  { templateId: 344, contract: 'Wearable', probability: null },
  { templateId: 346, contract: 'Wearable', probability: null },
  { templateId: 347, contract: 'Wearable', probability: null },
  { templateId: 348, contract: 'Wearable', probability: null },
  { templateId: 349, contract: 'Wearable', probability: null },
  { templateId: 350, contract: 'Wearable', probability: null },
  { templateId: 351, contract: 'Wearable', probability: null },
  { templateId: 352, contract: 'Wearable', probability: null },
  { templateId: 354, contract: 'Wearable', probability: null },
  { templateId: 355, contract: 'Wearable', probability: null },
  { templateId: 362, contract: 'Wearable', probability: null },
  { templateId: 363, contract: 'Wearable', probability: null },
  { templateId: 364, contract: 'Wearable', probability: null },
  { templateId: 365, contract: 'Wearable', probability: null },
  { templateId: 368, contract: 'Wearable', probability: null },
  { templateId: 369, contract: 'Wearable', probability: null },
  { templateId: 370, contract: 'Wearable', probability: null },
  { templateId: 371, contract: 'Wearable', probability: null },
  { templateId: 372, contract: 'Wearable', probability: null },
  { templateId: 373, contract: 'Wearable', probability: null },
  { templateId: 374, contract: 'Wearable', probability: null },
  { templateId: 375, contract: 'Wearable', probability: null },
  { templateId: 376, contract: 'Wearable', probability: null },
  { templateId: 377, contract: 'Wearable', probability: null },
  { templateId: 378, contract: 'Wearable', probability: null },
  { templateId: 389, contract: 'Wearable', probability: null },
  { templateId: 395, contract: 'Wearable', probability: null },
  { templateId: 396, contract: 'Wearable', probability: null },
  { templateId: 397, contract: 'Wearable', probability: null },
  { templateId: 399, contract: 'Wearable', probability: null },
  { templateId: 400, contract: 'Wearable', probability: null },
  { templateId: 403, contract: 'Wearable', probability: null },
  { templateId: 404, contract: 'Wearable', probability: null },
  { templateId: 406, contract: 'Wearable', probability: null },
  { templateId: 407, contract: 'Wearable', probability: null },
  { templateId: 408, contract: 'Wearable', probability: null },
  { templateId: 409, contract: 'Wearable', probability: null },
  { templateId: 410, contract: 'Wearable', probability: null },
  { templateId: 411, contract: 'Wearable', probability: null },
  { templateId: 412, contract: 'Wearable', probability: null },
  { templateId: 413, contract: 'Wearable', probability: null },
  { templateId: 415, contract: 'Wearable', probability: null },
  { templateId: 420, contract: 'Wearable', probability: null },
  { templateId: 422, contract: 'Wearable', probability: null },
  { templateId: 423, contract: 'Wearable', probability: null },
  { templateId: 424, contract: 'Wearable', probability: null },
  { templateId: 425, contract: 'Wearable', probability: null },
  { templateId: 426, contract: 'Wearable', probability: null },
  { templateId: 428, contract: 'Wearable', probability: null },
  { templateId: 429, contract: 'Wearable', probability: null },
  { templateId: 431, contract: 'Wearable', probability: null },
  { templateId: 432, contract: 'Wearable', probability: null },
  { templateId: 433, contract: 'Wearable', probability: null },
  { templateId: 434, contract: 'Wearable', probability: null },
  { templateId: 435, contract: 'Wearable', probability: null },
  { templateId: 436, contract: 'Wearable', probability: null },
  { templateId: 437, contract: 'Wearable', probability: null },
  { templateId: 442, contract: 'Wearable', probability: null },
  { templateId: 443, contract: 'Wearable', probability: null },
  { templateId: 444, contract: 'Wearable', probability: null },
  { templateId: 445, contract: 'Wearable', probability: null },
];
